import { SupportService } from "./support-service";

let supportService = new SupportService();

export { supportService }